import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e3ada1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "import-container" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Importación de Resultados del Clúster", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Periodo de Calibración")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instructions mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Seleccione un archivo "),
    /*#__PURE__*/_createElementVNode("strong", null, ".csv")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("Suelte el archivo aquí o "),
  /*#__PURE__*/_createElementVNode("em", null, "haga clic para cargar")
], -1))
const _hoisted_7 = { class: "actions mt-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Limpiar")

import { ref, computed } from "vue";
import { UploadFilled } from "@element-plus/icons-vue";
import { ElMessage, UploadFile } from "element-plus";
import Papa from "papaparse";
import { uploadClusterLabels } from "@/service/tmoa.service";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { getWaterTypes } from "@/service/waterType.service";
import { WaterType } from "@/types/waterType.type";
import { getImageById } from "@/service/image.service";

interface ClusterRecord {
  utc_datetime: string;
  image_id: string;
  typology_name: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore<RootState>();

const REQUIRED_COLUMNS = ["utc_datetime", "image_id", "typology_name"];
const EXTRA_WATER_TYPES = ["indeterminado", "invalido", "anomalia"];

const clusterData = ref<ClusterRecord[]>([]);
const validWaterTypes = ref<WaterType[]>([]);

const loading = ref<boolean>(false);

const previewData = computed(() => clusterData.value.slice(0, 5));

const isButtonDisabled = computed(() => clusterData.value.length === 0 || loading.value);

const validateHeaders = (headers: string[]): boolean => {
  return REQUIRED_COLUMNS.every((col) => headers.includes(col));
};

const handleFileChange = async (uploadFile: UploadFile): Promise<void> => {
  const file = uploadFile.raw;
  if (!file) return;

  loading.value = true;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: async (results) => {
      try {
        const { data, meta } = results;

        if (data.length === 0) return;
        if (!validateHeaders(meta.fields || [])) {
          ElMessage.error(`Columnas requeridas: ${REQUIRED_COLUMNS.join(", ")}`);
          resetData();
          return;
        }

        const firstRecord = data[0] as ClusterRecord;
        const imageInfo = await getImageById(Number(firstRecord.image_id));

        if (!imageInfo?.samplingPoint?.id) {
          throw new Error("No se pudo determinar el punto de la imagen.");
        }

        const waterTypes = await getWaterTypes(imageInfo.samplingPoint.id);
        validWaterTypes.value = waterTypes;

        const validNames = waterTypes.map((wt: WaterType) => wt.name);
        const allowedNames = [...validNames, ...EXTRA_WATER_TYPES];

        const invalidRows = (data as ClusterRecord[]).filter(
          (row) => !allowedNames.includes(row.typology_name)
        );

        if (invalidRows.length > 0) {
          const wrongNames = [...new Set(invalidRows.map((r) => r.typology_name))];
          ElMessage.warning(`Tipologías no encontradas: ${wrongNames.join(", ")}`);
          return;
        }

        clusterData.value = data as ClusterRecord[];
      } catch (error: any) {
        console.error(error);
        ElMessage.error(error.message || "Error al procesar el archivo");
        resetData();
      } finally {
        loading.value = false;
      }
    },
  });
};

const resetData = (): void => {
  clusterData.value = [];
};

const handleUpload = async (): Promise<void> => {
  loading.value = true;
  try {
    ElMessage.info(`Subiendo ${clusterData.value.length} registros...`);
    await uploadClusterLabels(clusterData.value, store.state.auth.user?.id || 0);
    ElMessage.success(`Subidos ${clusterData.value.length} registros.`);
  } catch (err) {
    console.error(err);
    ElMessage.error(`Error al subir el .csv`);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "box-card",
      shadow: "hover"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_tag, {
            type: "warning",
            effect: "dark"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          drag: "",
          action: "#",
          "auto-upload": false,
          "on-change": handleFileChange,
          "on-remove": resetData,
          limit: 1,
          accept: ".csv"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFilled))
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _: 1
        }),
        (clusterData.value.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _unref(previewData),
              style: {"width":"100%"},
              class: "mt-4",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "utc_datetime",
                  label: "Fecha/Hora (UTC)"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "image_id",
                  label: "ID Imagen",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "typology_name",
                  label: "Tipología"
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "success",
            disabled: _unref(isButtonDisabled),
            loading: loading.value,
            onClick: handleUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirmar e Importar (" + _toDisplayString(clusterData.value.length) + ") ", 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_el_button, { onClick: resetData }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})